import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { verifyEmailAddress as verifyEmailAddressAction } from '../../actions';

import BaseConfirmationScreen from '../BaseConfirmationScreen';
import BackArrow from '../Button/BackArrow';
import logo from '../../assets/images/logo_header.svg';
import loadGif from '../../assets/images/loading.gif';
import { SUPPORT_EMAIL } from '../../actions/urls';

import './index.css';


export class UnconnectedVerifyEmailAddress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      verified: false,
      error: false,
    };
  }

  async componentWillMount() {
    try {
      const { token } = this.props.match.params;
      await this.props.verifyEmailAddress(token);
      this.setState({ verified: true });
    } catch (err) {
      this.setState({ error: '!' });
    }
  }

  render() {
    let body;
    if (this.state.verified) {
      body = (<BaseConfirmationScreen
        backTo="/portfolio"
        backLabel="Summary"
        confirmationText="Account Verified"
        header="Thank you for verifying your account!"
        subtext={(
          <div styleName="subtext">
            Check out our exciting IPOs and other Offerings to start building your portfolio!  <Link styleName="subtextLink" to="/offers">Click here to continue.</Link>
          </div>)}
      />);
    } else if (this.state.error) {
      body = (
        <div styleName="verifyFailed">
          <div styleName="top">
            <BackArrow to="/" label="Home" />
            <img
              src={logo}
              alt="My IPO"
              styleName="logo"
            />
          </div>
          <div styleName="container">
            <div styleName="mainText">
              Email Verification Failed
            </div>
            <div styleName="subtext">
              Try clicking the verify email button in your verification email again or <a styleName="subtextLink" href={`mailto:${SUPPORT_EMAIL}`}>click here to contact support.</a>
            </div>
          </div>
        </div>);
    } else {
      body = (
        <div styleName="verifyFailed">
          <div styleName="top">
            <img
              src={logo}
              alt="My IPO"
              styleName="logo"
            />
          </div>
          <div styleName="container">
            <img src={loadGif} alt="Loading" />
          </div>
        </div>);
    }

    return body;
  }
}


const mapStateToProps = null;

const mapDispatchToProps = {
  verifyEmailAddress: verifyEmailAddressAction,
};


export default connect(mapStateToProps, mapDispatchToProps)(UnconnectedVerifyEmailAddress);



// WEBPACK FOOTER //
// ./src/components/VerifyEmailAddress/index.js